import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchReferralDashboardThunk,
  selectReferralState,
  setReferralCurrentPage,
} from "../store/referralSlice";

export const useReferralDashboard = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectReferralState);


  useEffect(() => {
    if (state.hasLoaded) return;
    dispatch(fetchReferralDashboardThunk());
  }, [dispatch, state.hasLoaded]);

  return {
    ...state,
    setCurrentPage: (value) => dispatch(setReferralCurrentPage(value)),
  };
};

export default useReferralDashboard;
